/**
 * Money formatting. Inventory amounts are DKK incl. moms.
 */

const dkk = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' });
const dkkWhole = new Intl.NumberFormat('da-DK', {
  style: 'currency',
  currency: 'DKK',
  maximumFractionDigits: 0,
});

/**
 * Format an amount as DKK ("1.234,50 kr."). Returns '—' for null/undefined.
 * @param {number|null|undefined} value
 * @param {{ whole?: boolean }} options - whole: drop the øre (for large totals)
 */
export const formatDKK = (value, { whole = false } = {}) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return (whole ? dkkWhole : dkk).format(value);
};

/**
 * An amount as an editable input value in Danish notation ("89,50"):
 * no currency sign, no thousands separator, at least two decimals.
 */
export const formatAmountInput = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '';
  return Number(value).toLocaleString('da-DK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
    useGrouping: false,
  });
};
